import type { OptimizelyFeatureKey, OptimizelyHookResult } from '@/optimizely/types'
import { useOptimizelyFeature } from '@/optimizely/utils'

export const usePricingModelFeatureSlot = (
    slot: number,
    categoryId: number,
    subCategoryId: number,
): OptimizelyHookResult => {
    const featureKey = `pricing_model_feature_${slot.toString()}` as OptimizelyFeatureKey
    return useOptimizelyFeature(
        featureKey,
        ({ variables }) => variables.subCategoryId === subCategoryId || variables.categoryId === categoryId,
    )
}
